import { ApiError, NetworkError } from '@/lib/api/problem'

export type ErrorCopy = {
  title:
    | 'errors.unexpectedTitle'
    | 'errors.networkTitle'
    | 'errors.serverTitle'
    | 'errors.notFoundTitle'
    | 'errors.forbiddenTitle'
    | 'errors.unauthorizedTitle'
    | 'errors.crmUnavailableTitle'
  description:
    | 'errors.unexpectedDescription'
    | 'errors.networkDescription'
    | 'errors.serverDescription'
    | 'errors.notFoundDescription'
    | 'errors.forbiddenDescription'
    | 'errors.unauthorizedDescription'
    | 'errors.crmUnavailableDescription'
}

export const describeError = (error: unknown): ErrorCopy => {
  if (error instanceof NetworkError) {
    return { title: 'errors.networkTitle', description: 'errors.networkDescription' }
  }

  if (error instanceof ApiError) {
    if (error.status === 401) {
      return { title: 'errors.unauthorizedTitle', description: 'errors.unauthorizedDescription' }
    }

    if (error.status === 403) {
      return { title: 'errors.forbiddenTitle', description: 'errors.forbiddenDescription' }
    }

    if (error.status === 404) {
      return { title: 'errors.notFoundTitle', description: 'errors.notFoundDescription' }
    }

    if (error.status === 503) {
      return {
        title: 'errors.crmUnavailableTitle',
        description: 'errors.crmUnavailableDescription',
      }
    }

    if (error.status >= 500) {
      return { title: 'errors.serverTitle', description: 'errors.serverDescription' }
    }
  }

  return { title: 'errors.unexpectedTitle', description: 'errors.unexpectedDescription' }
}
